// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { isEmpty, htmlEntities } from '@automator/utilities';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.logSidebarProperty.i18n;

// eslint-disable-next-line require-jsdoc
const PropertyChildMixin = ( superClass ) => class extends superClass {
	// Properties
	@property( { type: String, attribute: false } ) accessor type;

	@property( { type: String, attribute: false } ) accessor label;

	@property( { type: String, attribute: false } ) accessor value;

	@property( { type: Object, attribute: false } ) accessor attributes = {};

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="property">
				${ this._templateLabel }
				${ this._templateValue }
			</div>
		`;
	}

	/**
	 * Returns the template for the label of the property
	 *
	 * @return {TemplateResult|undefined} The label of the property
	 */
	get _templateLabel() {
		// Check if the label is defined
		if ( isEmpty( this.label ) ) {
			return;
		}

		return html`
			<div class="property-label">${ this.label }</div>
		`;
	}

	/**
	 * Returns the template for the value of the property
	 *
	 * @return {TemplateResult} The value of the property
	 */
	get _templateValue() {
		return html`
			<code class="property-value">
				${ ! isEmpty( this.value ) ? htmlEntities.decode( this.value ) : html`<em class="property-value__empty">${ strings.empty }</em>` }
			</code>
		`;
	}
}

export const AutomatorSidebarPropertyChild = PropertyChildMixin( LitElement );
